import type {DeviceStatus} from '@nursio-link/common';

import i18n from '@/i18n';

const pairedDeviceStatuses: Record<DeviceStatus, string> = {
  PENDING: i18n.t('deviceStatus.pending'),
  APPROVED: i18n.t('deviceStatus.approved'),
  REJECTED: i18n.t('deviceStatus.rejected'),
};

export default pairedDeviceStatuses;
